import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';

export const contactsService = { get, find };

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  },
  controller: 'Contacts'
};

function extract(r) {
  return r.data;
}

async function get() {
  return axios.post(`${model.baseUrl}${model.controller}/get`).then(extract);
}

async function find(lastName, firstName, middleName, email, phone, edrpou, allFields = '', orgName = '') {
  return axios
    .post(`${model.baseUrl}${model.controller}/find`,
      { lastName, firstName, middleName, email, phone, edrpou, allFields, orgName })
    .then(extract);
}
